import VendorOnboarding from "../components/VendorOnboarding/VendorOnboarding";

const VendorOnboardingPage = () => {
  return <VendorOnboarding />;
};

export default VendorOnboardingPage;
